var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomBlockManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "57px",
    viewBox: "0 0 60 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parsing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HotelRoom-Block-Beta",
    transform: "translate(-834.000000, -391.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(835.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sharp-table_chart-24px",
    transform: "translate(5.000000, 5.000000)",
    fill: "#E8CCFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8947368,19.89 L34.1052632,19.89 L34.1052632,51 L19.8947368,51 L19.8947368,19.89 Z M39.7894737,51 L54,51 L54,19.8333333 L39.7894737,19.8333333 L39.7894737,51 Z M54,0 L0,0 L0,14.1666667 L54,14.1666667 L54,0 Z M0,51 L14.2105263,51 L14.2105263,19.8333333 L0,19.8333333 L0,51 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sharp-table_chart-24px",
    stroke: "#8523D5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8947368,19.89 L34.1052632,19.89 L34.1052632,51 L19.8947368,51 L19.8947368,19.89 Z M39.7894737,51 L54,51 L54,19.8333333 L39.7894737,19.8333333 L39.7894737,51 Z M54,0 L0,0 L0,14.1666667 L54,14.1666667 L54,0 Z M0,51 L14.2105263,51 L14.2105263,19.8333333 L0,19.8333333 L0,51 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBlockManual);
export default __webpack_public_path__ + "static/media/room-block-manual.9fe0ee2585f713933da4f047e8b5ba66.svg";
export { ForwardRef as ReactComponent };